import React from 'react';
interface PageHeaderProps {
  title: string;
  backgroundImage?: string;
}
export function PageHeader({
  title,
  backgroundImage
}: PageHeaderProps) {
  return <div className="relative pt-36 pb-20 md:pt-48 md:pb-24 text-center overflow-hidden" data-id="element-422">
      {/* Background Image */}
      {backgroundImage && <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url(${backgroundImage})`
    }} data-id="element-423" />}

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-brand-dark/85" data-id="element-424" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-425">
        <h1 className="text-hero-mobile md:text-hero text-white font-heading font-bold" data-id="element-426">
          {title}
        </h1>
      </div>
    </div>;
}